export enum ProjectStatus {
  newBusiness = 1,
  prospect = 2,
  preQualified = 3,
  qualifiedPrePilot = 4,
  qualifiedInPilot = 5,
  qualifiedPilotComplete = 6,
  contracted = 7,
  onboarded = 8,
  active = 9,
  activeSuspended = 10,
  complete = 11,
  rejected=12,
  terminated = 13
}
